var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnte({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 14,
    viewBox: "0 0 29 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98163 9.46944L7.00323 4.05884H7.82643V5.04674H7.52913L6.02903 9.46944H4.98163ZM5.99703 8.04704L6.26223 7.32434H8.86013L9.12533 8.04704H5.99703ZM9.09793 9.46944L7.59773 5.04674V4.05884H8.11913L10.1452 9.46944H9.09793ZM10.5757 9.46944V4.05884H11.4447L14.5045 8.17504L13.8184 7.85034H14.3124V4.05884H15.2774V9.46944H14.413L11.3487 5.34854L12.0347 5.67334H11.5362V9.46944H10.5757ZM17.5511 9.46944V4.84544H15.7948V4.05884H20.3044V4.84544H18.5481V9.46944H17.5511ZM20.8218 9.46944V4.05884H24.4852V4.84544H21.8142V6.34564H24.3389V7.09574H21.8142V8.68274H24.4852V9.46944H20.8218Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3708 1.06445H7.38389C4.02135 1.06445 1.29547 3.79032 1.29547 7.15285C1.29547 10.5154 4.02135 13.2413 7.38389 13.2413H22.3708C25.7333 13.2413 28.4592 10.5154 28.4592 7.15285C28.4592 3.79032 25.7333 1.06445 22.3708 1.06445Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.93668
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnte);
export default __webpack_public_path__ + "static/media/ante.d42116437ce2783a1fefff0a6f92bd52.svg";
export { ForwardRef as ReactComponent };